import { LeasingRow } from "services/api/calculations/leasing/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const CALCULATION_LEASING_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: LeasingRow) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.name.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.leasing.search.name",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.name}</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.leasing.search.leasingtypename",
    field: "leasingTypeName",
    type: ColumnTypes.string,
  },
  {
    title: "admin.calculation.leasing.search.interestrate",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.interestRate} %</div>
        </div>
      );
    },
  },
];
